import * as React from 'react';

import { CardAvatarContainer } from '../CardAvatarContainer';
import { RealtorCard } from '../../components/RealtorCard';
import { ISpecialistCatalogListing } from '../../types/demand/specialistListing';

export interface IListOfRealtorsContainerProps {
  realtors: ISpecialistCatalogListing[];
  selectedRealtorsId: number[];
  selectRealtor: (id: ISpecialistCatalogListing) => void;
  unselectRealtor: (id: string) => void;
  onRealtorClick: (id: ISpecialistCatalogListing) => void;
  isButtonDisabled: boolean;
}

export const ListOfRealtorsContainer: React.FC<React.PropsWithChildren<IListOfRealtorsContainerProps>> = props => {
  const { realtors, onRealtorClick, selectRealtor, unselectRealtor, selectedRealtorsId, isButtonDisabled } = props;

  return (
    <>
      {realtors.map(realtor => {
        const { id, timeOnSite, agencyName, fullName, reviewsRate, reviewsCount, avatarUrl } = realtor;

        return (
          <RealtorCard
            key={id}
            onClick={() => onRealtorClick(realtor)}
            previewImg={<CardAvatarContainer imgUrl={avatarUrl} fullName={fullName} isCircleImage={true} />}
            agentId={id}
            timeOnSite={timeOnSite}
            agencyName={agencyName}
            hasRgrParticipation={false}
            name={fullName}
            rate={Number(reviewsRate) || 0}
            reviewsCount={reviewsCount}
            isSuperAgent={realtor?.qualityLevel === 4}
            selectRealtor={() => selectRealtor(realtor)}
            unselectRealtor={() => unselectRealtor(String(id))}
            isSelected={selectedRealtorsId.includes(id)}
            disabledButton={isButtonDisabled}
          />
        );
      })}
    </>
  );
};

ListOfRealtorsContainer.displayName = 'ListOfRealtorsContainer';
